(function () {
  'use strict';

  const target = document.querySelector('.js-scrollEn');
  if (!target) return;

  let targetW = target.offsetWidth;
  let targetH = target.offsetHeight;
  let windowH = window.innerHeight;

  // 初期位置
  const initialX = targetH;

  // 一度だけ初期位置をセット
  target.style.transform = `translateX(${initialX}px)`;

  function scrollFunc() {
    const rect = target.getBoundingClientRect();
    const isVisible = rect.top < windowH;

    if (!isVisible) {
      target.style.transform = `translateX(${initialX}px)`;
      return;
    }

    // 入ってからの距離で移動量を決める
    const distance = windowH - rect.top;
    let moveX = initialX - distance;

    const minX = -targetW;
    const finalX = Math.max(moveX, minX);

    target.style.transform = `translateX(${finalX}px)`;
  }

  // スクロール最適化 with requestAnimationFrame
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        scrollFunc();
        ticking = false;
      });
      ticking = true;
    }
  }

  // 初回実行 & イベント登録
  scrollFunc();
  window.addEventListener('scroll', onScroll);
  window.addEventListener('touchmove', onScroll);

  // オプション：画面リサイズ対応（必要なら）
  window.addEventListener('resize', () => {
    targetW = target.offsetWidth;
    targetH = target.offsetHeight;
    startY = target.offsetTop;
    windowH = window.innerHeight;
  });

})();
